import { registerLazyPopupRenderer } from "@/entities/bottom-popup"

registerLazyPopupRenderer(
	"easy-match-feedback",
	() => import("../ui/easy-match-feedback-popup"),
)
registerLazyPopupRenderer(
	"social-match-feedback",
	() => import("../ui/social-match-feedback-popup"),
)
